export default {
  en: {
    trial: 'Trial',
    remainingDays: '1 day remaining | {n} days remaining',
    endsToday: 'Ends today',
    trialTitle: 'Risk Ledger trial',
    paywall: {
      title: 'Your trial has ended',
      description:
        'Book time with our team to talk through what you explored during your trial and how Risk Ledger can support your supplier risk workflow.',
      returnToSupplier: 'You can also switch to supplier mode.',
      switchToSupplier: 'Switch to supplier mode',
      bookDemo: 'Book a demo',
    },
  },
};
